export default __webpack_public_path__ + "static/media/morph.7006dc5a.png";